import {RecordUtil} from '../infra/RecordUtil.service';
/**
 *
 * @ngdoc service
 * @name starter.service:searchService
 * @description
 * The access point to searching for results/clustering/recommendation
 * This service creates the request and parese the response in to the foam format which will be used to present the results
 *
 *
 * @example
 * searchService.search(this.query);
 * searchService.next_results();
 * searchService.previous_results();
 */

import {Cheetah} from './cheetah.service';
import {FacetService} from './facet/facet.service';
import {SearchResultParser} from './searchResultParser.service';
import {SearchBarService} from './searchBar/searchBar.service';
import {SearchStateService, ISearchObject} from './searchState.service';
import {ConfigurationUtil} from '../nddUtils/configurationUtil.service';
import {SearchUtil} from '../nddUtils/searchUtil.service';
import {getBlendFacetsSeparatelyConfig, getLocationsConfiguration, getPrimoVeSkipDelivery , getPrimoSplitFacetsMaxWait , getPrimoVeSplitFacetsWaitInterval} from '../appConfig/appConfigForward';
import {IAlertMsg} from '../infra/widgets/alerts/alertMsg.interface';
import {AlertFactory, ALERT_MSG_TYPE} from '../infra/widgets/alerts/alertFactory.service';
import {JwtUtilService} from '../security/jwtUtil.service';
import {RtaService} from './rta.service';
import {SearchFieldsService} from './search.fields.service';
import {getVid,getCurrentPCKey,getSEOParamsMapping} from '../appConfig/appConfigForward';
import { Injectable, Inject } from 'ng-metadata/core';
import {SnippetService} from './snippet/snippet.service';
import {HighlightsService} from './highlight/highlight.service';
import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';
import {RestUtils} from '../infra/restUtils.service';
import {PrimoResponse} from '../infra/dataStructures/PrimoResponses/searchResponseInterface';
import {preventStateReload} from '../infra/annotations';
import {UserSessionManagerService} from '../security/userSessionManager.service';
import {SavedQueryItem, IApiQueryItem} from '../favorites/savedQueries/savedQueries.service';
import {TimesCitedService} from './timesCited/timesCited.service';
import {updateZoteroPlugin} from '../nddUtils/zoteroUtil';
import {SearchHistoryService} from '../favorites/searchHistory/searchHistory.service';
import  {FilterInstitution} from '../nddUtils/filterInstitution.service'
import {JournalsService} from "../journals/journals.service";
import {DatabasesService} from "../journals/databases.service";
import {ResourceRecommenderService} from "./resourceRecommender/resourceRecommender.service";
import {NewspapersService} from '../newspapers/newspapers.service';
import {SearchErrorMessageService} from './searchResult/errorMessage/searchErrorMessage.service';
import {TranslationService} from "../translate/translation.service";

const flatten = require('lodash/flatten');
const forEach= require('lodash/forEach');
const he= require('he');
const join = require('lodash/join');
const remove= require('lodash/remove');
const findIndex= require('lodash/findIndex');
const _get = require('lodash/get');


@Injectable()
export class SearchService{
	private searchDone = false;
	private locationsTileConfiguration = getLocationsConfiguration();

	private _signInAlert :IAlertMsg;
	private _browseGapAlert :IAlertMsg;
	private _afterRedirectAlert :IAlertMsg;

	private vid:string= getVid();

	public cameFromState:string;
	public needToRender: boolean = true;

	public isFacetExact:boolean; //to detect if 'facet exact' search option was made from lateral links

	/* private members */
	private query:any;

	private reloadSearch : boolean = false ;
	private blendFacetsSeparatelyConf: boolean;

	private _isCategories;

    constructor(@Inject('$http') private $http : angular.IHttpService,
                private cheetah: Cheetah,
                @Inject('$stateParams') private $stateParams : angular.ui.IStateParamsService,
                @Inject('restBaseURLs') private restBaseURLs,
                private searchHistoryService:SearchHistoryService,
				private searchResultParser: SearchResultParser,
                private searchStateService: SearchStateService,
                private timesCitedService: TimesCitedService,
                private facetService: FacetService,
                @Inject('limit') private limit,
				@Inject('imagesBarLimit') private imagesBarLimit,
                private configurationUtil : ConfigurationUtil,
                private searchUtil: SearchUtil,
				@Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$location') private $location: ng.ILocationService,
                private searchBar: SearchBarService,
                private searchFieldsService: SearchFieldsService,
                private searchErrorMessageService: SearchErrorMessageService,
                private jwtUtilService : JwtUtilService,
				private alertService:AlertFactory,
                private rtaService: RtaService,
				private databasesService: DatabasesService,
                private resourceRecommender: ResourceRecommenderService,
				private snippetService:SnippetService,
				public highlightsService:HighlightsService,
                private restUtils: RestUtils,
                @Inject('$httpParamSerializer') private $httpParamSerializer: ng.IHttpParamSerializer,
                private userSessionManagerService: UserSessionManagerService,
                private recordUtil : RecordUtil,
				private filterInstitution: FilterInstitution,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
	            private journalsService: JournalsService,
				@Inject('$rootScope') private $rootScope: ng.IRootScopeService,
                private newspapersService: NewspapersService,
            @Inject('$q') private $q: ng.IQService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
				private translationService : TranslationService) {
        this.limit = limit;
        this.imagesBarLimit = imagesBarLimit;

		this.query ='';
		this.cameFromState ='';
		this.isFacetExact = false;
		//this.init();
		this._signInAlert = this.alertService.create(ALERT_MSG_TYPE.SIGNIN);
		this._browseGapAlert = this.alertService.create(ALERT_MSG_TYPE.BROWSE_GAP);
		this._afterRedirectAlert = this.alertService.create(ALERT_MSG_TYPE.SIMPLE);
		this.showAfterRedirectAlert();

		this.blendFacetsSeparatelyConf= getBlendFacetsSeparatelyConfig();
	}

	get signInAlert() :IAlertMsg {
		return this._signInAlert;
	}

	get browseGapAlert() :IAlertMsg {
		return this._browseGapAlert;
	}

	get afterRedirectAlert() :IAlertMsg {
		return this._afterRedirectAlert;
	}

	public showAfterRedirectAlert(){
		this.afterRedirectAlert.show('nui.message.fromredirect', false);
	}

	public hasBrowseGap() {
		let res = this.getResultObject();
		return (res != undefined && res.info != undefined && res.info.browseGap != undefined );
	}

	public resetSearchDone(){
    	this.searchDone = false;
	}

	public isSearchDone() {
		return this.searchDone;
	}
	public getItemAtIndex(index) {
		let item = this.searchStateService.getItemAtIndex(index);
		if(item) {
			return item;
		}
		if(!this.searchStateService.isSearchInProgress()){
			this.nextResults();
		}
	}

    public getRecommendationCount(recType){
        return this.resourceRecommender.getRecommendationCount(recType);
    }

    public resetResultObject(){
        this.searchStateService.resetResultObject()
    }

	/**
	 * @ngdoc function
	 * @name parseSearchResponse
	 * @methodOf starter.service:searchService
	 * @description This is the parser method that creates the following:
	 * 1. searchService.result_object.data
	 * 2. searchService.result_object.info
	 * 3. searchService.result_object.details
	 * 4. searchService.result_object.facets
	 */

	public parseSearchResponse(response, replaceResults = false) {
		let res = this.searchResultParser.parseSearchResponse(response);
		if(!this.needToRender){
		    this.searchStateService.setTempResultList(res.groups);
		}else{
		    this.searchStateService.setResultObject(res, replaceResults);
		}

		/*if MetaLib initial search then update the metaLibMore object to ignore all server more
		indication since it is fault - probably due to cached server responses*/
		if(_get(this.getSearchObject(),'getMore','') !== 1){
			this.handleMetaLibMoreStatus(true);
		}
		/* facets */
		if(!this.needToRender){
            this.facetService.setResult(res.facetsList);
        }else{
            this.facetService.setResult(this.getResultObject().facets);
        }
	}

    public performCitationTrailsSearch(facet){
        let args= this.searchStateService.getSearchObject();
        args.offset= 0;
        args.facets= this.getFacetsFromUrl([facet],false);
        this.searchStateService.resetResultObject();
        return this.search(args, true);
    }

    public performChaptersSearch(facets){
       let args= this.searchStateService.getSearchObject();
        args.offset= 0;
        args.facets= this.getFacetsFromUrl(facets,true);
        args.isRelatedItems = true;
        this.searchStateService.resetResultObject();
        return this.search(args, true);
    }

	/**
	 * @ngdoc function
	 * @name search
	 * @methodOf starter.service:searchService
	 * @description search wrapper
	 */
	public search(args, isNewSearch) {
		args.sortby = this.setSortBy(args);
		args.getMore = args.getMore || 0;
		if (isNewSearch) {
			this.searchStateService.setSearchObject(args);
		} else {
			this.searchStateService.updateSearchObject(args);
		}


		//get search resulst mark all more

        if(_get(this.getSearchObject(),'getMore','') !== 1){
            this.getSearchObject().metalibMoreStatus = {};
        }else{
        	// We only want to update the more indication
			// if this is fetch more - for initial search we do it after the search results are parsed
			this.handleMetaLibMoreStatus(false);
		}

		return this._search();
	}

	private setSortBy(args) {
		if ((args.journals && args.journals.split(",")[0]==="letter")||
			(args.databases && args.databases.split(",")[0]==="letter"))
			return "title";
		else
			return args.sortby || 'rank';
	}





	private handleMetaLibMoreStatus(isInitial){
		let updatedResultbject = this.getResultObject();
		let data = _get(updatedResultbject,'data','');

		let results = data.map((result,index)=>{
			let booster = _get(result, 'pnx.ranking.booster2');
			if(booster){
				if(!this.getSearchObject().metalibMoreStatus){
					this.getSearchObject().metalibMoreStatus = {};
				}
				let boosterValue = ++booster[0];
				if(isInitial){
					this.getSearchObject().metalibMoreStatus = {};
					boosterValue = 0;
				}
				this.getSearchObject().metalibMoreStatus[result.pnx.control.recordid[0]] = boosterValue;


			}
			return result;
		});
	}

	private setMessages(isGuest, isOffCampus){

        let groupMsg:number = this.configurationUtil.getBriefResultConfiguration().groupmessage;
        let isToDisplay:boolean = this.configurationUtil.getBriefResultConfiguration().displaysigninmsg;
		//when the message should be displayed - configuration + state:
		if (isToDisplay) {
			if((groupMsg === 0 && isGuest) || (groupMsg === 1 && isOffCampus)){
				this._signInAlert.show('nui.signin_message', false);
			}
		}
	}


	public restSignInAlertMessage(){
		this._signInAlert.show('', false);
	}
	/**
	 * @ngdoc function
	 * @name loadResultsup
	 * @methodOf starter.service:searchService
	 * @description This method broadcasts that the search finished to the follwoing controllers:
	 * 1. search-resul-list-controller
	 * In addition it broadcasts the scroll.infiniteScrollComplete event to let the controllers know
	 * that the ion-infinite-scroll had ended
	 */
	public loadResults(data, replaceResults=false) {
		this.parseSearchResponse(data, replaceResults);
	}

	/**
	 * @ngdoc function
	 * @name nextResults
	 * @methodOf starter.service:searchService
	 * @description paging wrapper
	 */
	public nextResults(replaceResults = false) {
		// all logic if to get next result must be handled in needToGetNextResults since the searchResult.directive.ts
		// is using same function (had to do it like that since beacon can't be called from a service)
		if (this.needToGetNextResults()) {
			this.searchStateService.nextBulk();
            this.getSearchObject().getMore = 0;
			return this._search(replaceResults, true).then(()=>{
                    if(replaceResults){
                        let newOffset= this.searchStateService.getSearchObject().offset;
                        if(newOffset != this.$stateParams['offset']){
                            this.updateOffsetInUrl(newOffset);
                        }
                    }
                });
		}
	}

    @preventStateReload
    updateOffsetInUrl(newOffset){
        this.$location.search('offset', newOffset);
    }

	public jumpToPage(page) {
		// all logic if to get next result must be handled in needToGetNextResults since the searchResult.directive.ts
		// is using same function (had to do it like that since beacon can't be called from a service)
		this.searchStateService.jumpToPage(page);
		this._search();
	}

	/**
	 * @ngdoc function
	 * @name needToGetNextResults
	 * @description check if needs to get next results.
	 * all logic if to get next result must be handled here
	 * since other laces might use this method too
	 */
	private needToGetNextResults() {
		return this.searchStateService.hasNextBulk();
	}


	/**
	 * @ngdoc function
	 * @name previousResults
	 * @methodOf starter.service:searchService
	 * @description paging wrapper
	 */
	public previousResults() {
		if (this.searchStateService.isNotFirstBulk()) {
			this.searchStateService.previousBulk();
			this._search();
		}

	}

	public getSearchObject() {
		return this.searchStateService.getSearchObject();
	}

	public getResultObject() {
		return this.searchStateService.getResultObject();
	}

	public selectItem(item) {
		this.searchStateService.selectItem(item);
	}

	public getSelectedItem() {
		return this.searchStateService.getSelectedItem();
	}

	/**
	 * @ngdoc function
	 * @name addImagesResults
	 * @methodOf starter.service:searchService
	 * @description This method parses the images search results and updates the page
	 */
	public addImagesResults(data) {
		this.parseImagesSearchResponse(data);
	}

	/**
	 * @ngdoc function
	 * @name parseImagesSearchResponse
	 * @methodOf starter.service:searchService
	 * @description This is the parser method that creates the following:
	 * 1. searchService.result_object.images
	 */

	public parseImagesSearchResponse(response) {
		let res = this.searchResultParser.parseImagesSearchResponse(response);
		this.searchStateService.addImagesToResultObject(res);
	}

	public isSearchInProgress() {
		return this.searchStateService.isSearchInProgress();
	}


	public getFrbrDisplay() {
        return this.configurationUtil.getBriefResultConfiguration().frbrdisplay;
	}






	public resetParameters(str = '') {


		let args = this.getSearchObject() || ({} as ISearchObject);
        this.getSearchObject().metalibMoreStatus = {};


		if(this.$stateParams['offset']) {
			args['offset'] = parseInt(this.$stateParams['offset'],10);
		}
        else{
            args['offset']= 0;
        }

		args.scope = this.searchUtil.urlParamScope || args.scope;
		args.tab = this.searchUtil.urlParamTab || args.tab;
		args.sortby = this.$stateParams['sortby'];
		args.explain = this.$stateParams['explain'];
        args.searchCDI = this.$stateParams['searchCDI'];
        let facetsFromUrl = this.getFacetsFromUrl(this.$stateParams['facet'],false);
        // Get multiple facets
        args.facets = facetsFromUrl.concat(this.getFacetsFromUrl(this.$stateParams['mfacet'],true));
        args.isRelatedItems = this.$stateParams['isRelatedItems'];

        if((this.$state.current.name === STATE_NAMES.SEARCH || this.$state.current.name === STATE_NAMES.NEWSPAPERS)
            && !(this.$stateParams['mode'] === "browse" || this.journalsService.isJournalSearch() || this.databasesService.isDBSearch() ||
                this.newspapersService.isNewspapersSearch())){
            let stickyFacetsArray = this.facetService.getStickyFacets();
            for (let stickyFacet of stickyFacetsArray){
                remove(args.facets, (facet) => this.facetService.isFacetEqual(facet,stickyFacet));
                args.facets.unshift(stickyFacet);
            }
        }

        args.journals = this.$stateParams['journals'];
        args.databases = this.$stateParams['databases'];
        args.featuredNewspapersIssnList = this.$stateParams['issn'];
        args.fromDate = this.$stateParams['fromDate'];
		args.pcAvailability = this.calcPcAvailability() || args.pcAvailabilty;
		args.browseParams= this.$stateParams['browseParams'];
		args.organization = this.$stateParams['organization'];

		args.getMore = 0;
		let query = this.$stateParams['query'] || args.query;

        if (Array.isArray(query)) {
            args.query = join(query,';');
            if (this.$stateParams['mode'] === 'simple') {
                args.query = query[0];
                this.updateQueryAfterSwitchingToSimpleMode(args);
            }
        }
        else {
            args.query = query;
            if (this.$stateParams['mode'] === 'simple') {
                this.updateQueryAfterSwitchingToSimpleMode(args);
            }
        }

		let mode = this.$stateParams['mode'];
		if (mode && mode === 'advanced') {
			args.mode = 'advanced';
			this.searchFieldsService.advancedSearch = true;
		}
		else{
            this.searchFieldsService.advancedSearch = false;
		}

		let pfilter = this.$stateParams['pfilter'];
        if (pfilter) {
            if (Array.isArray(pfilter)) {
                pfilter = join(pfilter,';');
            }

            if (this.configurationUtil.isSuprima()) {
                if (pfilter) {
                    args.query += ';' + pfilter;
                    this.updatePreFiltersQueryAfterSwitchingToSimpleMode(query, args);
                }
            } else {
                let facetPfilter = pfilter.replace('lang', 'facet_lang')
                    .replace('pfilter', 'facet_pfilter')
                    .replace('creationdate', 'facet_creationdate');

                if (facetPfilter) {
                    args.query += ';' + facetPfilter;
                    this.updatePreFiltersQueryAfterSwitchingToSimpleMode(query, args);
                }
            }
        }

		if(_get(this,['$stateParams','conVoc'], true) === 'false') {
			args['noConVoc'] = true;
		}

		if (query) {
			return this.search(args, true);
		}

	}

    private updateQueryAfterSwitchingToSimpleMode(args){
        let queryArr = (args.query.toString()).split(',');
        if (['AND', 'OR', 'NOT'].indexOf(queryArr[queryArr.length - 1]) > -1) {
            queryArr = queryArr.slice(0, queryArr.length - 1);
            args.query = queryArr.join(',');
        }
    }

    private updatePreFiltersQueryAfterSwitchingToSimpleMode(query, args) {
        if (this.$stateParams['mode'] === 'simple') {
            if (Array.isArray(query)) {
                args.query = query[0];
            } else {
                args.query = query;
            }
            this.updateQueryAfterSwitchingToSimpleMode(args);
        }
    }

    public getFacetsFromUrl(facetStrings,isMultiFacets) {
        if (!facetStrings) {
            return [];
        }
        let facetStringsArr = flatten([facetStrings]);
        let facets = facetStringsArr.map((facetString) => {
            let facetArr = facetString.split(',');
            let multiFacetGroupId;
            if (isMultiFacets) {
                multiFacetGroupId = facetArr.pop();//in case the facet is multi facet, the last parameter is the group id
            }
            for (let i = 3; i < facetArr.length; i++) { //this is in case facet value has ',' characters
                facetArr[2] = facetArr[2] + ',' + facetArr[i];
            }
            facetArr[2] = he.decode(facetArr[2]);
            facetArr = facetArr.slice(0, 3);
            let displayedType = this.facetService.displayedTypeFacet[facetArr[0].replace('facet_', '', 1)] || 'exact';

            let displayableFacet = this.filterInstitution.filterAndNormalizeDataFacets([{
                name: facetArr[0],
                value: facetArr[2]
            }]);

            let val = facetArr[2];
            let displayValue: string;
            if (displayableFacet && displayableFacet.length > 0) {
                val = this.facetService.facetLabel(displayableFacet[0]);
                displayValue = displayableFacet[0].displayValue;
            }

            let displayLabel = this.facetService.getFacetLabelValue(facetArr[0], facetArr[2]);
            if (displayLabel) {//case the sever sends a display value
                displayValue = displayLabel;
            }

            let facetView = this.configurationUtil.getFacetConfiguration().facetview;
            let relevantFacet = facetView.filter((facet) => {
                return facet.id === facetArr[0]
            });
            let useTranslate = relevantFacet.length > 0 ? relevantFacet[0].useTranslations : false;

            let facet = {
                name: facetArr[0],
                type: facetArr[1],
                value: facetArr[2],
                displayValue: displayValue,
                displayedType: displayedType,
                label: '',
                multiFacetGroupId: multiFacetGroupId,
                isMultiFacet: isMultiFacets,
                tooltip: '',
                useTranslation: useTranslate,
                translationsPromise:  undefined
            };
            //set a promise on the facet that will be resolved when all the facets label translations are done
            facet.translationsPromise= this.$q(async (resolve, reject) => {
                let label = await this.facetService.getFacetLabel(facetArr[0], displayedType, val);
                facet.label = label;
                let translation = await this.$translate(label, [], '', label);
                facet.label = translation;
                let prefix = this.$translate.instant('nui.facets.remove.tooltip');

                if (facetArr[0] === 'searchcreationdate') { //???
                    facetArr[0] = 'creationdate';
                }

                let typeName = this.$translate.instant('facets.facet.facet_' + facetArr[0]);
                if (this.configurationUtil.getBackendSystem() === 'suprima' && facetArr[0].startsWith("lds")) {
                    typeName = this.$translate.instant('fulldisplay.' + facetArr[0]);
                }
                let facetValue = (this.facetService.displayedTypeFacet[facet.name] === 'range') ?
                    facet.label :
					this.translationService.translateInstantWithDefault(this.facetService.facetLabel(facet), this.facetService.getFacetDefaultValue(facet));

                facet.tooltip = (facet.name !== 'frbrgroupid') ? prefix + typeName + ' ' + facetValue : prefix + typeName;
                resolve(facet); //signal that all translations are done for this facet
            });

            return facet;
        });
        return facets;
    }

    public get numOfLoadedResultBulks(): number{
        return this.searchStateService.numOfLoadedResultBulks;
    }


	private init() {
		this.resetParameters();
	}


    private reloadSearchAfterSLI(){
        if(this.reloadSearch){
            this.reloadSearch = false;
            this.$state.reload();
        }else{
            this.reloadSearch = true;
        }
    }

    //this function causes the search state to not be reloaded by router when we change the url search parameters
    private preventSearchStateReload(){
        let searchState= this.$state.current;
        //this wiil cause the router to not reload the search state when we change the search params in the url
        searchState.reloadOnSearch= false;

    }

	/**
	 * @ngdoc function
	 * @name _search
	 * @methodOf starter.service:searchService
	 * @description search wrapper
	 */
	private _search(replaceResults, isNextResultSearch) {
        this.preventSearchStateReload();
        this.$rootScope.$on('silentLogin',  ()=>{
            this.reloadSearchAfterSLI()});

		this.searchDone = true;
		let skipDelivery = this.configurationUtil.isSuprima() && !getPrimoVeSkipDelivery() ? 'N' : 'Y';
		this.searchStateService.setSkipDelivery(skipDelivery);
		let searchObject = this.getSearchObject();
		this.searchStateService.setSearchInProgress(true);
		this.searchBar.setShowSignIn(false);
        let resultObject = this.getResultObject();

		// need cleaner solution for limit and imagesBarLimit
		//if(this.$state.params['mode']=== 'browse') {
		//	searchObject.scope = "browse_search";
		//}

		let searchOffset = searchObject.offset | 0;
		let blendFacetsSeparately = this.blendFacetsSeparatelyConf && this.cheetah.isScopeBlended(searchObject.scope) && searchOffset === 0;
		searchObject['blendFacetsSeparately'] = blendFacetsSeparately;



		window.appPerformance.timeStamps['before search api']= Date.now();
		let p = this.cheetah.performSearch(searchObject, resultObject.info, true).then(
			(response:{data:PrimoResponse.ISearchResponse})=> {
				if (this.configurationUtil.isSuprima()){
               this.getFacetsRetry(response, searchObject, resultObject);
            }
				if (blendFacetsSeparately){
					let originalFacets= this.searchResultParser.parseSearchResponse(response.data).facetsList;
					response.data.facets= [];
					setTimeout(()=>{
						searchObject['blendFacetsSeparately'] = false;
						this.cheetah.performSearch(searchObject, resultObject.info, true, true).then((response:{data:PrimoResponse.ISearchResponse})=> {
							let result = this.searchResultParser.parseSearchResponse(response.data);
							this.facetService.setResult(result.facetsList);
						}, (err)=>{
							//if there was a failure in the second call use the facets from the first call
							this.facetService.setResult(originalFacets);
						});
					}, 650);
				}
				if(!this.configurationUtil.isSuprima()){
					let deliveryServiceUrl = this.restBaseURLs.pnxBaseURL + '/delivery?'
					+ this.$httpParamSerializer(this.cheetah.searchData);
					this.$http.post(deliveryServiceUrl,{
						"records":response.data.docs
					}).then(
						(dResponse) => {
                            let data:PrimoResponse.ISearchResponse = dResponse.data;
							dResponse.data.docs.forEach((doc,index) => {
								response.data.docs[index].delivery = doc.delivery;
                                data.docs[index].context = response.data.docs[index].context;
								if(doc['@rta_link'] && dResponse.data.docs[index]['@rta_link']){
									response.data.docs[index]['@rta_link'] = dResponse.data.docs[index]['@rta_link'];
									data.docs[index]['@rta_link'] = dResponse.data.docs[index]['@rta_link'];
								}

							});
                            let dmTimer = data.timelog.FullEndDMDataDeltaTime;
							if(dResponse.data.rtaResultsLink){
								response.data.rtaResultsLink = dResponse.data.rtaResultsLink;
								data.rtaResultsLink = dResponse.data.rtaResultsLink;
							}
                            window.appPerformance.serverTimeLog['FullEndDMDataDeltaTime'] = dmTimer;
							if (this.configurationUtil.getLocationsConfiguration() &&
								this.configurationUtil.getLocationsConfiguration().rta !== 'none') {
								this.rtaService.updateAvailability(data.docs);
							}
						});
				}
				else if(this.searchStateService.getSkipDelivery() === 'Y') {

					let mmsIds = response.data.docs
						.map((doc) => doc.pnx.control.recordid[0])
						.filter(recordId => recordId.match(/^alma.*/)).toString();

					if(mmsIds) {
						this.$http.post(this.restBaseURLs.deliveryURL + "?" + this.$httpParamSerializer(this.cheetah.searchData),
							mmsIds
						).then(
							(dResponse) => {
								response.data.docs.forEach((doc) => {
									let dataToAdd = dResponse.data.filter(item => item.pnx.control.recordid[0].match(doc.pnx.control.recordid));
									if(dataToAdd.length) {
										doc.delivery = dataToAdd[0].delivery;
										doc.enrichment = dataToAdd[0].enrichment;
										if(dataToAdd[0].pnx.display.crsinfo) {
											doc.pnx.display.crsinfo = dataToAdd[0].pnx.display.crsinfo;
										}
										if(dataToAdd[0].pnx.display.dedupmemberids) {
											doc.pnx.display.dedupmemberids = dataToAdd[0].pnx.display.dedupmemberids;
										}
									}
								});
						});
					}
				}

			    this.reloadSearch = false;
				window.appPerformance.timeStamps['after search api']= Date.now();
				let data:PrimoResponse.ISearchResponse = response.data;
				window.appPerformance.serverTimeLog= data.timelog;
                let searchState= this.$state.current; //get the configuration of the search state from the router
				searchState.reloadOnSearch= true; //return reload on search to true so that back button in browser works



				this.recordUtil.loadRecordsExtras(data.docs);

				/*
                 * Notice that loadResults(data); in its deep call update the newSearch to false
                 * This happens in setResultObject(searchResponse) API in SearchStateService
                 * the handleSnippet API must be called before the loadResults API
                 */
				if(!this.$stateParams['journals'] && !this.$stateParams['databases'] && !this.$stateParams['browseScope']) {
					this.snippetService.updateSnippets(data.docs);
				}

                //this.timesCitedService.updateCitedTimesAvailability(data.docs);
				this.loadResults(data, replaceResults);
				this.searchStateService.setSearchInProgress(false);

                /*
                Highlights service
                */
                this.highlightsService.updateHighlights(data.highlights);


				let isGuest = this.jwtUtilService.getDecodedToken().userGroup === 'GUEST';
				let isOffCampus = this.jwtUtilService.getDecodedToken().onCampus !== 'true';

				if (isGuest) {
					this.setMessages(isGuest, isOffCampus);
				}
				this._browseGapAlert.show('nui.browseGap_message', false);
				this.afterRedirectAlert.hide();
				updateZoteroPlugin(); //send event so that zotero plugin identifies new results


			},
			(response) => {
                let searchState= this.$state.current; //get the configuration of the search state from the router
                searchState.reloadOnSearch= true; //return reload on search to true so that back button in browser works

				let err = response.data;
				if (!err){
					return;
				}
				let beaconSearchErrorMessage = "Error code: " + (response.status ? response.status : response.data.errorCode)
                                            + ", Error message: " + response.data.errorMessage;//to add to failed search beacon calls
                beaconSearchErrorMessage = beaconSearchErrorMessage.substring(0, 100);
                let emptyResult = {
                    docs: [],
                    facets: [],
                    info: { first: '1', last: '0', total: '0', beaconSearchErrorMessage : beaconSearchErrorMessage, errorDetails : {errorCode : this.searchErrorMessageService.serverError}},
                };
				this.loadResults(emptyResult);
				this.searchStateService.setSearchInProgress(false);
				if (err.errorMessage === 'Not Authorized') {
				    this.reloadSearchAfterSLI();
					this.searchBar.setShowSignIn(true);
					this._signInAlert.hide();
				}
			}

		).then((res) => {
			if(!(this.$stateParams['mode'] === "browse" || this.journalsService.isJournalSearch() || this.databasesService.isDBSearch() ||
				this.newspapersService.isNewspapersSearch())){
            	this.searchHistoryService.updateSearchHistory(); //saves the current search query URL to the browser, on the local forage, after every search action (of any type).
			}
        });
		return p;
	}


    public IsScopeLocal(scope?) {
        let scopesContext;
        if(scope)
            scopesContext = window.appConfig['scopes-context-map'][scope];
        else if (this.$stateParams['mode'] === "browse")
            scopesContext = "L";
        else if (this.searchFieldsService.scope)
            scopesContext = window.appConfig['scopes-context-map'][this.searchFieldsService.scope];
        else
            scopesContext="";
        return (scopesContext === "L" );
    }


	public calcPcAvailability(){
		if(this.$state.current.name === STATE_NAMES.CITATION_TRAILS){
			return true;
		}
        if(this.$state.current.name === STATE_NAMES.NEWSPAPERS){
			let pcAvailability = this.$stateParams['pcAvailability'] ? this.$stateParams['pcAvailability'] : false;
            return pcAvailability;
        }

		return this.$stateParams['pcAvailability'] ||
			!this.facetService.showPcAvailabilityForScope(this.$stateParams['search_scope']);
	}

	public updatePageTitle(){
        let oneWordQuery = this.searchFieldsService.mainSearch;
        try {
            this.$translate(['nui.brief.title'],{ query: oneWordQuery }).then((translations)=> {
                // set the page title from label
                let titleElement = <HTMLLinkElement>document.getElementById('primoExploreTitle');
                titleElement.innerHTML = translations['nui.brief.title'];
                titleElement.innerHTML = titleElement.innerHTML.replace(/\s*\-\s*$/, "");
            });
        }
        catch (e) {
            console.log("translation of 'nui.brief.title' is corrupt");
        }

	}


	public updatePageTitleFullView(recordTitle,institutionCode){
		try {
			this.$translate(institutionCode).then((translatedInstCode) => {
				let placeHolders = {recordTitle:recordTitle, institutionName:translatedInstCode};
				this.$translate(['nui.full.display.title'],placeHolders).then((translations)=> {
					// set the page title from label
					let titleElement = <HTMLLinkElement>document.getElementById('primoExploreTitle');
					titleElement.innerHTML = translations['nui.full.display.title'];
					titleElement.innerHTML = titleElement.innerHTML.replace(/\s*\-\s*$/, "");
				});
			});
		}
		catch (e) {
			console.log("translation of 'nui.brief.title' is corrupt");
		}

    }

    public updatePageDescriptionFullView(recordDescription) {
        try {
			let x = <HTMLMetaElement>document.getElementsByName("description")[0];
			x.content=recordDescription;
        }catch (e) {
            console.log("Not exists meta element description in index");
        }

	}

	public clearPageTitle(){
		let titleElement = <HTMLLinkElement>document.getElementById('primoExploreTitle');
        titleElement.innerHTML = "";
	}

	public clearPageDescription(){
		this.updatePageDescriptionFullView("");
	}

    public updatePageKeywordsFullView(recordDescription) {
        try {
			let x = <HTMLMetaElement>document.getElementsByName("keywords")[0];
			x.content=recordDescription;
        }catch (e) {
            console.log("Not exists meta element keywords in index");
        }

    }

    public getRecordId(itemControl) {
        let recordId = itemControl.recordid[0];
        if (recordId.startsWith('dedupmrg') || recordId.startsWith('TN_dedupmrg')) {
            let originalRecordId = itemControl.sourcerecordid[0];
            let index = originalRecordId.indexOf('$$O');
            if (index !== -1) {
                originalRecordId = originalRecordId.substring(index + 3);
            }
            return originalRecordId;
        }
        return recordId;


    }
    

    
 
    
	public getRestToSDOType(type){
		switch(type){
			case 'article': return 'Article';
			case 'audio': return 'CreativeWork';
			case 'book': return 'Book';
			case 'bookChapter': return 'Chapter';
			case 'collection': return 'CreativeWork';
			case 'conference_proceeding': return 'Article';
			case 'database': return 'CreativeWork';
			case 'dissertation': return 'Thesis';
			case 'GovernmentDocument': return 'Book';
			case 'image': return 'Photograph';
			case 'journal': return 'Periodical';
			case 'kit': return 'CreativeWork';
			case 'LegalDocument': return 'Book';
			case 'manuscript': return 'Book';
			case 'map': return 'Map';
			case 'newspaper': return 'Periodical';
			case 'NewspaperArticle': return 'NewsArticle';
			case 'other': return 'CreativeWork';
			case 'ReferenceEntry': return 'CreativeWork';
			case 'ResearchDataset': return 'Dataset';
			case 'Review': return 'Review';
			case 'score': return 'CreativeWork';
			case 'StatisticalDataSet': return 'CreativeWork';
			case 'TechnicalReport': return 'Report';
			case 'text_resource': return 'CreativeWork';
			case 'video': return 'Movie';
			case 'website': return 'WebSite';
			case 'print_book': return 'Book';
			case 'book_chapter': return 'Chapter';
			case 'report': return 'Report';
			case 'journal_article': return 'Article';
			case 'Conference-Paper': return 'Article';		
		}
	}

      
	public getScheameDotOrg(item, title){
		let schema = {};
		schema['@context']='http://schema.org';
		schema['@type']='WebPage';
		
		// permalink add location
		let url = this.$location.url();
		schema['@id']=url;
		
		let idenntifier = {};
		idenntifier['@type']='PropertyValue';
		idenntifier['propertyID']='local';
		let control=_get(item, 'pnx.control');
		idenntifier['value']=this.getRecordId(control);
		
		schema['identifier']=idenntifier;
		
		let name = title;
		schema['name']=name;
		
		// create main entity
		let mainEntity = {};
		let type = _get(item, 'pnx.display.type[0]', 'book');
		let sotype = this.getRestToSDOType(type);
		mainEntity['@type']=sotype;
		mainEntity['@id']='#'+sotype;
		
		// add creator
		try{
			let pnxau=_get(item,'pnx.addata.addau');
			if(pnxau) {
				let creator = [];
				for(let auel of pnxau){
					let auelo = {};
					auelo['@type']='Person';
					auelo['name']=auel;
					creator.push(auelo);
				}
				mainEntity['creator']=creator;
			}
		}catch(e){
			console.log(item);
			console.log(e);
		}
		
		// add author
		try{
			let pnxaucorp=_get(item,'pnx.display.aucorp');
			if(pnxaucorp) {
				let contributor = [];
				for(let auel of pnxaucorp){
					let auelo = {};
					auelo['@type']='Person';
					auelo['name']=auel;
					contributor.push(auelo);
				}
				mainEntity['contributor']=contributor;
			}
		}catch(e){
			console.log(item);
			console.log(e);
		}
		
		// add description
		try{
			let pnxdesc=_get(item,'pnx.display.description');
			if(pnxdesc) {
				let description = [];
				for(let desc of pnxdesc){
					description.push(desc);
				}
				mainEntity['description']=description;
			}
		}catch(e){
			console.log(item);
			console.log(e);
		}
		
		// add edition
		try{
			let workExample=_get(item,'pnx.display.edition[0]');
			if(workExample) {
				mainEntity['edition']=workExample;
			}
		}catch(e){
			console.log(item);
			console.log(e);
		}
		
		// Issn/eissn
		try{
			let pnxissn=_get(item,'pnx.addata.issn');
			let issn = [];
			if(pnxissn) {
				for(let prissn of pnxissn){
					issn.push(prissn);
				}
			}
			pnxissn=_get(item,'pnx.addata.eissn');
			if(pnxissn) {
				for(let prissn of pnxissn){
					issn.push(prissn);
				}
			}
			if(issn.length>0) mainEntity['issn']=issn;
		}catch(e){
			console.log(item);
			console.log(e);
		}
		
		// indentifier
		
		let indentifier = {};
		indentifier['@type']='PropertyValue';
		let indentifiers = [];
		
		let val = _get(item,'pnx.display.sici');
		if(val) {
			let disval ={};
			disval['propertyID']='SICI';
			disval['value']=val;
			indentifiers.push(disval);
		}
		val = _get(item,'pnx.display.coden');
		if(val) {
			let disval ={};
			disval['propertyID']='CODEN';
			disval['value']=val;
			indentifiers.push(disval);
		}
		val = _get(item,'pnx.display.ean');
		if(val) {
			let disval ={};
			disval['propertyID']='EAN';
			disval['value']=val;
			indentifiers.push(disval);
		}
		val = _get(item,'pnx.display.lccallnum');
		if(val) {
			let disval ={};
			disval['propertyID']='LCCallNum';
			disval['value']=val;
			indentifiers.push(disval);
		}		
		val = _get(item,'pnx.display.pmid');
		if(val) {
			let disval ={};
			disval['sameAs']='https://www.ncbi.nlm.nih.gov/pubmed/'+val;
			indentifiers.push(disval);
		}
		val = _get(item,'pnx.display.pmid');
		if(val) {
			let disval ={};
			disval['sameAs']='https://lccn.loc.gov/'+val;
			indentifiers.push(disval);
		}
		
		if(indentifiers.length>0){
			indentifier['indentifier']=indentifiers;
		 	mainEntity['indentifier']=indentifier;
		}
		
		
		
		//sameAs
		let sameas = {};
		sameas['@type']='PropertyValue';
		let sameases = [];
		let val = _get(item,'pnx.links.uri');
		if(val) {
			let disval ={};
			disval['propertyID']='uri';
			disval['value']=val;
			disval['sameAs']='http://dx.doi.org/'+val;
			sameases.push(disval);
		}
		val = _get(item,'pnx.display.doi');
		if(val) {
			let disval ={};
			disval['propertyID']='doi';
			disval['value']=val;
			disval['sameAs']='http://dx.doi.org/'+val;
			sameases.push(disval);
		}
		if(sameases.length>0){
			sameas['sameas']=sameases;
		 	mainEntity['sameas']=sameas;
		}
		
		
		// inLanguage
		try{
			let inLanguage=_get(item,'pnx.display.language[0]');
			if(inLanguage) {
				mainEntity['inLanguage']=inLanguage;
			}
		}catch(e){
			console.log(item);
			console.log(e);
		}
		
		// publisher
		val = _get(item,'pnx.display.publisher');
		if(val) {
			let disval ={};
			disval['@type']='Organization';
			disval['name']=val;
			mainEntity['publisher']=disval;
		}
		
		
		// creationdate
		val = _get(item,'pnx.display.creationdate[0]');
		if(val) {

			mainEntity['publisher']=val;
		}	
		
		
		// about
		try{
			let pnxabout=_get(item,'pnx.display.subject');
			if(pnxabout) {
				let pnxabouts = [];
				for(let auel of pnxabout){
					let auelo = {};
					auelo['@type']='Thing';
					auelo['name']=auel;
					pnxabouts.push(auelo);
				}
				mainEntity['about']=pnxabouts;
			}
		}catch(e){
			console.log(item);
			console.log(e);
		}			
		
		// url
		val = _get(item,'pnx.addata.url[0]');
		if(val) {

			mainEntity['url']=val;
		}
		
		
		
		switch(sotype){
			case 'Book':
				val = _get(item,'pnx.addata.isbn[0]');
				if(val) {
		
					mainEntity['isbn']=val;
				}				
				val = _get(item,'pnx.display.format[0]');
				if(val) {
		
					mainEntity['bookFormat']=val;
				}				
				val = _get(item,'pnx.display.relation[0]');
				if(val) {
		
					mainEntity['isPartOf']=val;
				}				
				break;
			case 'Article':
			case 'Periodical':
			case 'Chapter':
				let isPartOf = {};
				isPartOf['@id'] = '#periodical';
				let t = ['PublicationVolume', 'Periodical'];
				isPartOf['@type']=t;
				val = _get(item,'pnx.addata.title[0]');
				if(val) {		
					isPartOf['name']=val;
				}else{
					val = _get(item,'pnx.addata.btitle[0]');
					if(val)	isPartOf['name']=val;
					
				}				
				val = _get(item,'pnx.addata.issn[0]');
				if(val) isPartOf['issn']=val;
				val = _get(item,'pnx.addata.volume[0]');
				if(val) isPartOf['PublicationVolume']=val;
				val = _get(item,'pnx.display.periodical[0]');
				if(val) isPartOf['PublicationTitle']=val;
				mainEntity['isPartOf']=isPartOf;
				val = _get(item,'pnx.addata.volume[0]');
				if(val) mainEntity['volumeNumber']=val;
				val = _get(item,'pnx.display.duns[0]');
				if(val) mainEntity['duns']=val;
				val = _get(item,'pnx.display.publicationplace[0]');
				if(val) mainEntity['Place']=val;
				val = _get(item,'pnx.display.relation[0]');
				if(val) mainEntity['additionalType']=val;
				val = _get(item,'pnx.display.periodical[0]');
				if(val) mainEntity['PublicationTitle']=val;
				val = _get(item,'pnx.addata.startpage[0]');
				if(val) mainEntity['pageStart']=val;
				val = _get(item,'pnx.addata.endpage[0]');
				if(val) mainEntity['pageEnd']=val;
				val = _get(item,'pnx.addata.pages[0]');
				if(val) mainEntity['pagination']=val;
				val = _get(item,'pnx.addata.issue[0]');
				if(val) mainEntity['issueNumber']=val;
						
				
				
				
				break;
			case 'Photograph':
				break;
			case 'CreativeWork':
				break;
			case 'Movie':
				break;
			default:
				console.log('Not defined type: ' + sotype);
		}
		
			
		
		schema['mainEntity']=mainEntity;
		// finish main entity'
		return schema;
	}
    
    public updateSDO(schema) {
        try {
        	//console.log(schema);
			let allscripts = document.getElementsByTagName("script");
			for(let alscript of  allscripts){
				//console.log (alscript ) ;
				//console.log (alscript.type ) ;
				
				if(alscript.type==='application/ld+json'){
					
					alscript.innerHTML = JSON.stringify(schema);
					return;
				}
			}
			console.log (' NOT FOUND application/ld+json script ' ) ;
			/*
			let alscripts = allscripts.filter(s => s.type === 'application/ld+json');
			if(alscripts){
				let alscript = alscripts[0];
				alscript.innerHTML = schema;
				
			}else{
				console.log (' NOT FOUND application/ld+json script ' ) ;
			}
			*/
        }catch (e) {
        	console.log(e);
            console.log("Error application/ld+json script");
        }

    }
    
    
    public addSEOData(item, title){
    	this.updatePageTitle();
    	let schema=this.getScheameDotOrg(item, title);
	    this.updateSDO(schema);
	    this.updatePageDescriptionFullView(title);    	
    }
    
    public removeSEOData(){
    	this.updatePageTitle();
	    this.updateSDO({});
	    this.updatePageDescriptionFullView("");    	
    }
    
	public setCategories(iscategories){
		this._isCategories=iscategories;
	}

	public isCategories(){
		return this._isCategories;
	}

    public getReferenceEntry(query) {

        let dataToBeSent = {
                query: query,
                pckey:getCurrentPCKey()
            };

        let deliveryServiceUrl = this.restBaseURLs.pnxBaseURL + '/delivery?'
                    + this.$httpParamSerializer(this.cheetah.searchData);

        let refEntryUrl = this.restBaseURLs.referenceEntryUrl;
        if (this.configurationUtil.isSuprima()) {
            refEntryUrl = refEntryUrl + "?vid=" + this.vid;
        }
            return this.$http.post(refEntryUrl,dataToBeSent).then(
        (response:{data:PrimoResponse.ISearchResponse})=> {
                if(response.data){
                    let doc: any[] = [response.data];
                    if (this.configurationUtil.isSuprima()) {
                        return doc;
                        } else {
                        return this.$http.post(deliveryServiceUrl,{
                            "records":[response.data]
                        })
                    }
                } else {
                    return null;
                }
            });
    }

    getFacetsRetry(response, searchObject, resultObject){
        if (_get(response,'data.facets',[]).length === 0){
           let maxWaitTime = getPrimoSplitFacetsMaxWait();
           let timeout = this.$timeout(()=>{}, maxWaitTime);
           this.getFacets(searchObject, resultObject, timeout);
        }
   }

    getFacets(searchObject, resultObject, timeout){
        this.cheetah.performFacetSearch(searchObject, resultObject.info).then((facetResponse:{data:PrimoResponse.ISearchResponse})=>{
            let result = this.searchResultParser.parseSearchResponse(facetResponse.data);
            if (_get(result,'facetsList',[]).length > 0) {
                this.$timeout.cancel(timeout); //facets retrieved. Therefore we can stop the clock
                this.facetService.setResult(result.facetsList);
            }
            else{
                let waitInternal = getPrimoVeSplitFacetsWaitInterval();
                let waitBetweenTriesTimeout = this.$timeout(()=>{
                    this.getFacets(searchObject, resultObject, timeout); //wait some time and try to get facets again
                }, waitInternal);

                timeout.then(()=>{ //timeout limit reached
                    this.$timeout.cancel(waitBetweenTriesTimeout); //cancel any pending facet retrieval attempts
            });
         }
        }, (err)=>{
        	this.$timeout.cancel(timeout);
        });
   }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/search.service.ts